import React from "react";
import { fileUrl, language, useFETCH } from "../../Tools/APIs";
import { ImageUser } from "../../components";
import { content } from "../../Context/translate";
import { Link } from "react-router-dom";
const NavChat = ({ id }) => {
  // const { data, isLoading } = useFetch(id ? "v1/users/show/" + id : "");
  const { data, isLoading } = useFETCH(id ? "v1/users/show/" + id : "");
  let dataAll = data?.data?.data;
  return (
    <div
      className={`bg-white h-[10vh] px-5 py-2 sticky top-[1px] max-md:absolute max-md:top-0 max-md:z-50 select-none left-0 w-full shadow-lg z-10 flex items-center ${
        language === "ar" ? "justify-end" : ""
      } `}
    >
      <div
        className={`flex w-full items-center justify-between ${
          language === "ar" ? "flex-row-reverse" : ""
        } `}
      >
        <div
          className={`flex gap-5 items-center ${
            language === "ar" ? "flex-row-reverse" : ""
          }`}
        >
          <ImageUser
            image={dataAll?.image ? fileUrl + dataAll?.image : ""}
            id={id}
            className="w-12 h-12"
          />
          {!isLoading && (
            <div
              className={`font-semibold ${
                language === "ar" ? "text-right" : "text-left"
              } `}
            >
              <div className="">{dataAll?.secret_data?.name}</div>
              <div>
                {dataAll?.is_online ? (
                  <span className="text-green-500 ">{content.Online}</span>
                ) : (
                  <span className="text-red-500 ">
                    {dataAll?.last_active_at
                      ? dataAll?.last_active_at
                      : content.Offline}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
        <div>
          <Link to={"/chat"}>
            <span className="text-xl text-Secondary font-bold">X</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavChat;
